/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Alert, Spinner, Pagination } from "react-bootstrap";
import { useGetCarsQuery } from "../../redux/createApi";

const SearchBrand = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const heading = params.get("heading");
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const size = 12;

  const { data, isLoading, error } = useGetCarsQuery({ page, size, make:heading  });
  
  const totalPages = data?.pages || 1;
  const currentPage = data?.page || page;

  if (isLoading) {
    return (
      <div className="text-center my-4">
        <Spinner animation="border" variant="primary" />
        <p className="mt-2">Loading cars...</p>
      </div>
    );
  }

  if (error) {
    return (
      <Alert variant="danger" className="mt-4 text-center">
        <Alert.Heading>Oops! Something went wrong.</Alert.Heading>
        <p>We couldn't fetch the cars at the moment. Please try again later.</p>
        {error?.status && <hr />}
        <p className="mb-0">
          <strong>Error Code:</strong> {error?.status}
        </p>
      </Alert>
    );
  }

  const getPaginationItems = () => {
    const items = [];
    const startPage = Math.max(1, currentPage - 2);
    const endPage = Math.min(totalPages, currentPage + 2);

    for (let i = startPage; i <= endPage; i++) {
      items.push(
        <Pagination.Item
          key={i}
          active={i === currentPage}
          onClick={() => setPage(i)}
        >
          {i}
        </Pagination.Item>
      );
    }

    return items;
  };

  return (
    <>
      <section>
        <div className="container">
          <div className="row">
            {data?.data.map((e) => (
              <div className="col-md-4" key={e?.id}>
                <div className="car-item wow fadeInUp" data-wow-delay=".25s">
                  <div className="car-img">
                    <span className="car-status status-1">Used</span>
                    <img
                      src={
                        e?.link_img_hd?.length > 0
                          ? e?.link_img_hd[0]
                          : "/assets/img/car/01.jpg"
                      }
                      alt=""
                    />
                    <div className="car-btns">
                      <a href="#">
                        <i className="far fa-heart"></i>
                      </a>
                      <a href="#">
                        <i className="far fa-arrows-repeat"></i>
                      </a>
                    </div>
                  </div>
                  <div className="car-content">
                    <div className="car-top">
                      <h4>
                        <a href="#">{e?.title}</a>
                      </h4>
                      <div className="car-rate">
                        <i className="fas fa-star"></i>
                        <i className="fas fa-star"></i>
                        <i className="fas fa-star"></i>
                        <i className="fas fa-star"></i>
                        <i className="fas fa-star"></i>
                        <span>5.0 (58.5k Review)</span>
                      </div>
                    </div>
                    <ul className="car-list">
                      <li>
                        <i className="far fa-steering-wheel"></i>
                        {e?.transmission}
                      </li>
                      <li>
                        <i className="far fa-road"></i>
                        {e?.engine_size}
                      </li>
                      <li>
                        <i className="far fa-car"></i>Model: {e?.model}
                      </li>
                      <li>
                        <i className="far fa-gas-pump"></i>
                        {e?.fuel}
                      </li>
                    </ul>
                    <div className="car-footer">
                      <span className="car-price">{e?.current_bid}</span>
                      <button
                        className="theme-btn"
                        onClick={() =>
                          navigate(`/detail/${e?.id}`, { state: { data: e } })
                        }
                      >
                        <span className="far fa-eye"></span>Details
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
            <div className="d-flex justify-content-center my-4">
              <Pagination>
                <Pagination.First
                  onClick={() => setPage(1)}
                  disabled={currentPage === 1}
                />
                <Pagination.Prev
                  onClick={() => setPage(currentPage - 1)}
                  disabled={currentPage === 1}
                />
                {getPaginationItems()}
                <Pagination.Next
                  onClick={() => setPage(currentPage + 1)}
                  disabled={currentPage === totalPages}
                />
                <Pagination.Last
                  onClick={() => setPage(totalPages)}
                  disabled={currentPage === totalPages}
                />
              </Pagination>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SearchBrand;
